var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 8,
    r: 4,
    fill: "#181A1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49886 21H3.49341C2.66828 21 2 20.1913 2 19.1965C2 17.3581 2.50008 15.479 3.75027 14.4405C5.33232 13.1316 7.62585 12.9745 9.49886 13.0036C11.3741 12.9716 13.6677 13.1316 15.2497 14.4405C16.4999 15.4761 17 17.3552 17 19.1965C17 20.1913 16.3317 21 15.5066 21H9.50114H9.49886Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.75C19.5 7.33579 19.1642 7 18.75 7C18.3358 7 18 7.33579 18 7.75V9.5H16.25C15.8358 9.5 15.5 9.83579 15.5 10.25C15.5 10.6642 15.8358 11 16.25 11H18V12.75C18 13.1642 18.3358 13.5 18.75 13.5C19.1642 13.5 19.5 13.1642 19.5 12.75V11H21.25C21.6642 11 22 10.6642 22 10.25C22 9.83579 21.6642 9.5 21.25 9.5H19.5V7.75Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/addPerson.3c18a729ba1306d0fea22148200cf9cd.svg";
export { ForwardRef as ReactComponent };